<template>
  <div>
    <a href="#" @click="!$atividades.permissoes.includes(15) == false ? modalCertificadoEmpresa = true : 1">
        <feather-icon :style="!$atividades.permissoes.includes(15) == true ? 'color: lightgrey;': ''" icon="FileTextIcon" class="mr-2" />
    </a>
    <SideBar
      title="Certificado da empresa"
      @hide="cancelar"
      :disabled="!$atividades.permissoes.includes(15)"
      :active="modalCertificadoEmpresa"
      size="small"
      textSucces="Atualizar"
      @success="atualizarCertificado()"
    >
      <div slot="body">
        <VuePerfectScrollbar class="scroll-edit-certificado-empresa" :settings="settings">
          <div class="pr-3 w-full">
            <label class="cert-file-label" for="cert-file-input">Certificado (.pfx)</label>
            <b-form-file
              id="cert-file-input"
              :state="Boolean(file)"
              name="foto"
              accept=".pfx"
              @change="uploadFunc($event)"
              placeholder="Atualizar certificado..."
              drop-placeholder="arraste aqui..."
            ></b-form-file>
            <p v-if="possuiCertificado && !file" class="cert-status-ok">
              ✓ Certificado já cadastrado para esta empresa
            </p>
            <vs-input
              v-model="senha"
              type="password"
              label-placeholder="Senha do certificado"
              class="w-full cert-senha-input"
              name="senha_certificado"
            />
          </div>
        </VuePerfectScrollbar>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "modalCertificadoEmpresa",
  props: {cnpj: null, possuiCertificado: {type: Boolean, default: false}},
  data() {
    return {
        file: null,
        certificadoBase64: null,
        senha: null,
        modalCertificadoEmpresa: false,
        settings: {
            maxScrollbarLength: 60,
            wheelSpeed: 0.8,
            height: 1000
        },
    };
  },
  methods: {
    async uploadFunc($event) {
      let file = $event.srcElement.files[0];
      this.file = file;
      let reader = new FileReader();
      reader.onload = (fileEvent) => {
        this.certificadoBase64 = fileEvent.target.result;
      };
      reader.readAsDataURL(file);
    },
    async atualizarCertificado() {
      // Arquivo guardado no componente (nao mais em localStorage): antes
      // usava uma chave global (CERT_EMP) compartilhada por toda instancia
      // do modal, podendo vazar o .pfx de uma empresa pro cnpj de outra
      // quando aberto pra mais de uma linha da lista sem selecionar arquivo
      // de novo.
      if (!this.certificadoBase64) {
        this.$vs.notify(this.$notify.Custom("Atenção", "Selecione o arquivo do certificado (.pfx).", "warning"));
        return;
      }
      if (!this.senha) {
        this.$vs.notify(this.$notify.Custom("Atenção", "Informe a senha do certificado.", "warning"));
        return;
      }
      this.$vs.loading();
      let data = {}
      data.certificado = this.certificadoBase64;
      data.cnpj = await this.cnpj
      data.senha = this.senha
      try {
        const res = await this.$http.post("updateCertificado", data);
        let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: 'EDITAR',
            setor: 'ADMIN',
            ip: window.localStorage.getItem("ip"),
            texto: 'EDITAR CERITIFCADO DA EMPRESA' + res.cnpj}
        await this.$logger(logData)
        this.$vs.notify(this.$notify.Success);
        this.limparFormulario();
        this.modalCertificadoEmpresa = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/");
        };
      } finally {
        this.$vs.loading.close();
        // Emitido so depois do loading.close() (mesmo padrao de
        // excluirEmpresa/mudarStatusEmpresa em editar.vue) — emitir antes
        // deixava o refetch do pai (getEmpresas) rodando em paralelo com o
        // loading deste modal ja fechado, e se aquele GET falhasse (ex:
        // token expirado), o "sucesso" do certificado virava um logout
        // confuso logo em seguida. Sem isso, a lista de empresas no pai
        // tambem nunca era recarregada apos salvar — a tela "esquecia" que
        // o certificado ja tinha sido cadastrado ao sair e voltar (#314).
        this.$emit("update");
      }
    },
    limparFormulario() {
      this.file = null;
      this.certificadoBase64 = null;
      this.senha = null;
    },
    cancelar() {
      this.limparFormulario();
      this.modalCertificadoEmpresa = false;
    }
  },
  components: { ...components, moment, Datepicker }
};
</script>

<style>
.scroll-edit-certificado-empresa {
  height: 70vh !important;
}
</style>

<style scoped>
/* Label estatico acima do input de arquivo (antes nao tinha nenhum, e o
   label flutuante do vs-input logo abaixo acabava sobrepondo visualmente
   o campo de arquivo por falta de espaco entre os dois - #314). */
.cert-file-label {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.cert-status-ok {
  color: #28c76f;
  font-size: 13px;
  margin: 8px 0 0;
}
.cert-senha-input {
  margin-top: 28px;
}
</style>
